import { render, staticRenderFns } from "./updateReceipt.vue?vue&type=template&id=9bec8396&scoped=true&"
import script from "./updateReceipt.vue?vue&type=script&lang=ts&"
export * from "./updateReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./updateReceipt.vue?vue&type=style&index=0&id=9bec8396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bec8396",
  null
  
)

export default component.exports